import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import { If, Then, ElseIf, Else } from 'react-if-elseif-else-render';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Footer from './Footer.js';
import PageBanner from './PageBanner.js';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import PreLoginPage from '../../../views/core/PreLoginPage';
import HmAjax from '../../../util/HmAjax';
import $ from 'jquery';
import HmEventRegistry from '../../../model/HmEventRegistry';
import ProductConfig from '../../../config/ProductConfig.json';

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
    padding				  : '0px',
    maxWidth				  : '1170px'
  }
};

Modal.setAppElement('#root');

const response = [];
const gradeNo = '';
const ProductList = [];
const proClass = '';
const grades = [];

// ES6 class-style
class Grades extends PreLoginPage<(match)> {
  
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
      error: null,
      isLoaded: false,
      items: [],
      ProductList: [],
      pro_detail: [],
      products_details: {}
    //  products : {self:ProductConfig["SPL"].productKey,plp:ProductConfig["PLP"].productKey,test:ProductConfig["EXAM_PREP_CBSE"].productKey}
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.grades = this.props.grades;
    this.productClass = this.props.products_class;
    this.productClasses = this.props.classes;
    this.products_category = this.props.products_category;
    this.checkProductAvailability = this.checkProductAvailability.bind(this);
    this.singleLink = null;
    this.selected_ga = null;
  }

  componentDidMount() {
  	this.setState({isLoaded: true});
  	this.grades = this.props.grades;
  	this.productClass = this.props.products_class;
  	this.productClasses = this.props.classes;
    this.products_category = this.props.products_category;
    HmEventRegistry.fireEvent("INITIATE_GA");
    HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
  }

  saveIDs(proID){
  	localStorage.setItem('product',proID);  
  	console.log(proID);  
  	return false;
  }

  afterOpenModal = async event => {
	  //GoogleAnalytics.GA();
	  HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
	  var me =this;
	  var callBackSuccess = function(result){
		if(result !== null){
			
			me.setState({
	          products_details: result
	        }),
	       	console.log(me.state.products_details);
	        localStorage.setItem('proDetail',JSON.stringify(me.state.products_details));
		}

		//console.log("response : ", response);
		}
	
		var callBackFailure = function(response){
			me.setState({
			    isLoaded: true,
			    error:"Error in PRODUCT_JSON"
			  });
			console.log("Error in PRODUCT_JSON in Grade");		
		}
	
		var formData = {
				"levelId":this.gradeNo
		}
		new HmAjax(this.getUrlFor("PRODUCT_JSON"),formData).post(callBackSuccess,callBackFailure);
		
		
		$(document).ready(function(){
	    	console.log($('.pro-box').length);
	    	if($('.pro-box').length === 1){
	    		$('.pro-box').addClass('pro-box-100');
	    	}else if($('.pro-box').length === 2){
	    		$('.pro-box').addClass('pro-box-50');
	    	}else{
	    		$('.pro-box').addClass('pro-box-33');
	    	}
	    });
  }
  getSingleProductNavigation(){
	  var me =this;
	  var callBackSuccess = function(result){
			if(result !== null){
				
				me.setState({
		          products_details: result
		        }),
		        me.saveIDs(Object.keys(result)[0]);
		        localStorage.setItem('proDetail',JSON.stringify(me.state.products_details));
		        window.top.location.href=me.singleLink;
			}

		//console.log("response : ", response);
		}
	
		var callBackFailure = function(response){
			me.setState({
			    isLoaded: true,
			    error:"Error in PRODUCT_JSON"
			  });
			console.log("Error in PRODUCT_JSON in Grade");		
		}
	
		var formData = {
				"levelId":this.gradeNo
		}
		new HmAjax(this.getUrlFor("PRODUCT_JSON"),formData).post(callBackSuccess,callBackFailure);
  }
  
  checkProductAvailability(event){	  	
	    this.gradeNo = event.target.id;
	    this.ProductList = (Object.keys(this.products_category));
	    localStorage.setItem('grade',this.gradeNo);
	    
	    //console.log("sdf=",this.state.products);
	    let availableProductCount = 0;
	    for (var i = 0; i < this.ProductList.length; i++) {
	  		if(ProductConfig.hasOwnProperty(this.ProductList[i])){
	  			var proid = this.products_category[this.ProductList[i]][this.gradeNo];
		        if(this.products_category[this.ProductList[i]][this.gradeNo] != undefined){
		        	availableProductCount++;
		        	
		        	this.singleLink = ProductConfig[this.ProductList[i]].url+proid;
		        	 
		        	/* 
		        	if(this.ProductList[i] == 'PLP'){
				        this.singleLink = '/personalised-learning/'+proid;
				    }else if(this.ProductList[i] == 'SPL'){
				    	this.singleLink = '/self-learning/'+proid;
				    }else if(this.ProductList[i] == 'EXAM_PREP_CBSE'){
				    	this.singleLink = '/cbse-exam/'+proid;
				    }*/
		        	
		        }
	  		}
	  	}
	    //console.log("availableProductCount="+availableProductCount);
	    if(availableProductCount == 1){
	    	this.getSingleProductNavigation();	    	
	    }else{
	    	this.openModal(event);
	    }

  }
  openModal(event){ console.log("open modal 111"); 
  	const { products,products_details } = this.state;
    this.setState({modalIsOpen: true});
    this.gradeNo = event.target.id;
    this.ProductList = (Object.keys(this.products_category));
    localStorage.setItem('grade',this.gradeNo);
    this.selfLearn = '';
    this.plp = '';
    this.test = '';
    console.log(this);
    this.selected_ga = $(event.target).data("ga");
    // for (var i = 0; i < this.ProductList.length; i++) {
    //   if(this.ProductList[i] == products.self){
    //     this.setState({selfLearn: this.products_category[this.ProductList[i]][this.gradeNo]});
    //   }else if(this.ProductList[i] == products.plp){
    //     this.setState({plp: this.products_category[this.ProductList[i]][this.gradeNo]});
    //   }else{
    //     this.setState({test: this.products_category[this.ProductList[i]][this.gradeNo]});
    //   }
    // }
    
    for (var i = 0; i < this.ProductList.length; i++) {
  		if(this.ProductList[i] == products.self){
	        if(this.products_category[this.ProductList[i]][this.gradeNo] != undefined){
		        const sid = this.products_category[this.ProductList[i]][this.gradeNo];
		        console.log("sid=="+sid);
		        console.log(this.props);
		          this.selfLearn = <div className="pro-box float-left">
		            <div className="e-box e-h2">
		              <span><img src="../img/e1.png" alt=""/></span>
		              <h2>In understanding concepts better</h2>
		              <hr className="h-line"/>
		              <p>Self-Paced Lessons</p>
		              <div className="e-btn">
		                <Link data-ga={this.selected_ga+" - Self-Paced Lessons"} to={"/self-learning/"+sid} className="r-btn" onClick={() => this.saveIDs(`${sid}`)}>select</Link>
		              </div>    
		            </div>
		          </div>
	        }
  		}else if(this.ProductList[i] == products.plp){

        if(this.products_category[this.ProductList[i]][this.gradeNo] != undefined){ console.log("render..");
        const pid = this.products_category[this.ProductList[i]][this.gradeNo];
        console.log(this.products_details);
      //  console.log(this.props.pid);
          this.plp = <div className="pro-box float-left">
                <div className="e-box e-h2">
                  <span><img src="../img/e3.png" alt=""/></span>
                  <h2>To score better in school tests</h2>
                  <hr className="h-line"/>
                  <p>Personalised Learning</p>
                  <div className="e-btn">
                    <Link  data-ga={this.selected_ga+" - Personalised Learning"} to={"/personalised-learning/"+pid} className="r-btn" onClick={() => this.saveIDs(`${pid}`)}>select</Link>
                  </div>    
                </div>
              </div>
        }

  		}else{
        if(this.products_category[this.ProductList[i]][this.gradeNo] != undefined){ console.log("render..");
        const cid = this.products_category[this.ProductList[i]][this.gradeNo];
          this.test = <div className="pro-box float-left">
                <div className="e-box e-h2">
                  <span><img src="../img/e2.png" alt=""/></span>
                  <h2>To achieve your best in the board exams</h2>
                  <hr className="h-line"/>
                  <p>CBSE Exam Prep</p>
                  <div className="e-btn">
                    <Link data-ga={this.selected_ga+" - CBSE Test Prep"} to={"/cbse-exam/"+cid} className="r-btn" onClick={() => this.saveIDs(`${cid}`)}>select</Link>
                  </div>    
                </div>
              </div>
        }

  		}
  	}

  }


  closeModal() {
    this.setState({modalIsOpen: false});
  }

  checkRestrictedGrade(grade){
	 var restricted = ""
	 if(this.GradeRestrictionManager.isGradeRestricted(grade)){
		restricted = "restricted";
	 }
	 return restricted;
  }

  render() {
  	this.grades = this.props.grades;
  	this.productClass = this.props.products_class;
  	this.productDetails = this.props.products_details;
  	this.productClasses = this.props.classes;
    this.products_category = this.props.products_category;
  	const img = '';
  	const { error, isLoaded, items,selfLearn,plp,test,products_details } = this.state;
  	const gradeItem = '';

     if (error) {
      return <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
      return <div className="text-center">Loading...</div>;
    } else if(this.grades !== [] && this.grades !== undefined){

    //	console.log("grades::",this.grades);
			// console.log("grades productClasses::",this.productClasses);
			
    	this.gradeItem = this.grades.map(item => {
    		if(this.productClasses && this.productClasses[item]){
    			return ( <div data-ga={"Products - "+this.productClasses[item].ClassName} className={"grade-box popup-modal "+this.checkRestrictedGrade(item)} key={item} onClick={this.checkProductAvailability} id={item}> 
					
						<div className="g-img"> 
		 	 			<img src={this.productClasses[item].thumbnail} alt=""/>		 	 			
	 	 			</div>
	 	 			<div className="g-text">
	 	 				<p>{this.productClasses[item].ClassName}</p>
	 	 			</div> 
	 	 			{(() => {
							if(this.checkRestrictedGrade(item) == "restricted"){
								return (<div className="text-center desktopinfo"><p>{this.rb("msg.desktop")}</p></div>);
							}
					})()}
	 	 		</div>
	        )
    		}


    		}
	      )
    
    }  
	    return(
	    	
	  		<section className="product-main  mt-30">
			 	<div className="container">  
			 	 	<h2>Which grade are you interested in?</h2> 
			 	 	<div className="row grade-list">
							{this.gradeItem}
			 	 	</div>
			 	</div> 

			 	<Modal isOpen={this.state.modalIsOpen} onRequestClose={this.closeModal} onAfterOpen={this.afterOpenModal} style={customStyles}>
				 	<div id="grade-modal" className="white-popup-block grade-popup">	 
						<a data-ga={this.selected_ga +" - Close"} className="popup-modal-dismiss" onClick={this.closeModal}><img src="../img/cross.png" alt=""/></a>
						<h3>What do you need help with?</h3>
						<div className="prod-list clearfix">
				            {this.selfLearn}
				            {this.plp}
							{this.test}
						</div>
					</div>
				</Modal>
		
			</section>

	  	);

  	
  }
}

ReactDOM.render(<Grades />, document.getElementById('root'));
export default Grades;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/Grades.js